import { httpClient, postProcessUpsert } from "@genai/http-client";
import {ApiChatMessage, type ChatId, role} from "../model";
import { AssistantId } from "@genai/assistant";

export const createMessage = async (
  assistantId: AssistantId,
  chatId: ChatId,
  query: string | undefined,
  filters: unknown
): Promise<ApiChatMessage | undefined> => {
  if (!query) {
    return;
  }
  return httpClient(`/assistants/${assistantId}/chats/${chatId}/messages`, {
    method: "POST",
    body: JSON.stringify({
      role: role.user,
      content: query,
      filters: filters,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(postProcessUpsert<ApiChatMessage>);
};
